const INITIAL_STATE = {
  data: {},
  errors: {},
        
}
const DeleteAccountInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'DELETE_LOG_PAYMENT_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'DELETE_LOG_PAYMENT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default DeleteAccountInvoice;